import { Switch, useRouteMatch, Route, Redirect } from "react-router-dom";
import ContainerRoute from "@src/components/common/routing/container-route";

import { DevicesList } from "./list/index.jsx";

export default function Devices({ responsiveStyles = {} }) {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <ContainerRoute
        exact={true}
        path={path}
        component={DevicesList}
        responsiveStyles={responsiveStyles}
      ></ContainerRoute>
      <Route path={`${path}/*`}>
        <Redirect to={path} />
      </Route>
    </Switch>
  );
}
